'use strict';

import { setTimeout } from 'timers';
import store from './store';

const bulkAddEventListener = function bulkAddEventListener(
  object,
  events,
  callback
) {
  events.forEach(function(event) {
    object.addEventListener(event, function(event) {
      callback(event);
    });
  });
};

const bulkRemoveEventListener = function bulkRemoveEventListener(
  object,
  events = [],
  handler
) {
  events.forEach(function(event) {
    try {
      object.removeEventListener(event, handler);
    } catch (error) {
      console.log('engine idle: ', error);
    }
  });
};

class IdleJs {
  constructor(options) {
    this.defaults = {
      debug: false,
      aliveTime: 5 * 60 * 1000,
      idleTime: 20 * 60 * 1000, // idle time in ms
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
      onIdle() {}, // callback function to be executed after idle time
      onActive() {}, // callback function to be executed after back form idleness
      onAlive() {}, // callback function to be executed after back form idleness
      onHide() {}, // callback function to be executed when window become hidden
      onShow() {}, // callback function to be executed when window become visible
      keepTracking: true, // set it to false of you want to track only once
      startAtIdle: false, // set it to true if you want to start in the idle state
      recurIdleCall: false,
      storePrefix: 'idle' // string sufix to localstorage key
    };
    this.settings = Object.assign({}, this.defaults, options);
    this.settings.idle = this.settings.getIdleTime.call(); // convert into ms
    this.settings.keepAliveTime = this.settings.aliveTime * 60 * 1000; // convert into ms
    this.idle = this.settings.startAtIdle;
    this.visible = !this.settings.startAtIdle;
    this.visibilityEvents = [
      'visibilitychange',
      'webkitvisibilitychange',
      'mozvisibilitychange',
      'msvisibilitychange'
    ];
    this.lastId = null;
    this.aliveId = null;
    this.store = store;
    this.storeKey = `${this.settings.storePrefix}`;
  }

  isExpired() {
    const now = Date.now();
    const lastActive = this.store.get(this.storeKey);
    const timeleft = lastActive + this.settings.getIdleTime.call();
    const diff = timeleft - now;
    const isTimeout = diff < 0;
    return isTimeout;
  }

  resetTimeout(id, settings) {
    let now = Date.now();
    this.store.set(this.storeKey, now);
    if (this.idle) {
      settings.onActive.call();
      this.notify('active');
      this.idle = false;
    }
    clearTimeout(id);
    if (this.settings.keepTracking) {
      return this.timeout(this.settings);
    }
  }

  check() {
    if (this.idle) {
      return;
    }
    const isTimeout = this.isExpired();

    if (isTimeout) {
      this.idle = true;
      this.settings.onIdle.call();
      this.notify('ideal');
    } else {
      clearTimeout(this.lastId);
      this.lastId = this.timeout();
    }
  }

  timeout() {
    var timer = this.settings.recurIdleCall ? setInterval : setTimeout;
    var id;
    timer.bind(this);
    id = timer(
      function() {
        this.check();
      }.bind(this),
      this.getIdleTime(this.settings.getIdleTime.call())
    );
    return id;
  }

  keepAlive(id) {
    if (this.idle) {
      clearInterval(this.aliveId);
      this.aliveId = null;
    } else if (!this.aliveId) {
      clearInterval(this.aliveId);
      var timer = setInterval;
      timer.bind(this);
      this.aliveId = timer(
        function() {
          this.settings.onAlive.call();
          this.notify('alive');
          this.keepAlive(this.aliveId);
        }.bind(this),
        this.settings.keepAliveTime
      );
    }
  }

  notify(msg) {
    if (this.settings.debug) {
      console.log(
        this.settings.storePrefix,
        'IdleTabs: ',
        Date().slice(16, 25),
        this.settings.getIdleTime.call() / (1000 * 60),
        msg
      );
    }
  }

  reset() {
    bulkRemoveEventListener(window, this.settings.events, this.eventHandler);
    bulkRemoveEventListener(
      window,
      this.visibilityEvents,
      this.visibilityHandler
    );
    this.keepAlive();
    this.lastId = this.resetTimeout(this.lastId, this.settings);
    this.notify('reset');
    this.settings.idle = this.settings.getIdleTime.call();
  }

  getIdleTime(duration) {
    const now = Date.now();
    const lastActive = store.get(this.storeKey) || now;
    const remainingTime = duration - (now - parseInt(lastActive, 10));
    return remainingTime;
  }

  eventHandler() {
    this.lastId = this.resetTimeout(this.lastId, this.settings);
  }

  visibilityHandler() {
    if (
      document.hidden ||
      document.webkitHidden ||
      document.mozHidden ||
      document.msHidden
    ) {
      if (this.visible) {
        this.visible = false;
        this.settings.onHide.call();
        this.notify('hidden');
      }
    } else if (!this.visible) {
      this.visible = true;
      this.settings.onShow.call();
      this.notify('visible');
    }
  }

  start() {
    this.keepAlive();
    this.notify('initialized');
    this.lastId = this.timeout(this.settings);
    bulkAddEventListener(
      window,
      this.settings.events,
      this.eventHandler.bind(this)
    );
    if (this.settings.onShow || this.settings.onHide) {
      bulkAddEventListener(
        document,
        this.visibilityEvents,
        this.visibilityHandler.bind(this)
      );
    }
  }
}

export default IdleJs;
